import router from './router'
import store from './store'
// import 'nprogress/nprogress.css' // progress bar style
import {getToken, removeToken, isGuestSession, clearGuestSessionFlag} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

// NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/find-password','/WorkSheet/Index/1'] // no redirect whitelist

// router.beforeEach(async(to, from, next) => {
//     // start progress bar
//     // NProgress.start() 

//     // set page title
//     document.title = getPageTitle(to.meta.title)
//     const {username, password} = JSON.parse(localStorage.getItem('loginInfo')) ?? {};
//     var un,ps;
//     un=username;
//     ps=password;
//     // determine whether the user has logged in
//     var hasToken = getToken();

//     var toPath = to.path;
//     var quer = to.query;
//     // console.log('abc',toPath,quer,hasToken)
//     if (toPath.startsWith('/WorkSheet/SheetViewParent/') && quer.token ){
//         // console.log('a1')
//         var dataid = toPath.replace('/WorkSheet/SheetViewParent/','')
//         var token = dataid + '_' + quer.token
//         // console.log(dataid,quer.token)
//         // var aa = await store.dispatch('user/quickLogin', {token:quer.token,toPath})
//         var aa = await store.dispatch('user/quickLogin', {token,toPath})
//         // console.log('aa',aa, store.state.user)
//             localStorage.setItem('loginInfo', JSON.stringify({
//               password:store.state.user.password,
//               username:store.state.user.userName,
//               userId: store.state.user.userId
//             }));
//         hasToken = getToken();
//         un=store.state.user.userName;
//         ps=store.state.user.password;
//         await store.dispatch('user/getUserMenu');
//         // console.log('hasToken',hasToken,un,ps)
//     }
    
//     if (hasToken && un && ps) {
//         if (to.path === '/login') {
//             // if is logged in, redirect to the home page
//             next({path: '/'})
//             // NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
//         } else {

//             try {
//                 // console.log('do',store.state.user,store.state.user.slideData)
//                 // get user info
//                 // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
//                 await store.dispatch('user/getUserCompany', {un, ps});
//                 if (!store.state.user?.slideData?.length) {
//                     // console.log('jinru11111',un,ps)
//                     await store.dispatch('user/login', {username:un, password:ps});
//                     // console.log('do2',store.state.user.slideData)
//                     await store.dispatch('user/getUserMenu');
//                     // console.log('do3',store.state.user.slideData)
//                 }
//                 // console.log('do next'),
//                 // hack method to ensure that addRoutes is complete
//                 // set the replace: true, so the navigation will not leave a history record
//                 next()
//             } catch (error) {
//                 removeToken();
//                 next(`/login`)
//                 // NProgress.done()
//             }
//         }
//     } else {
//         /* has no token*/

//         if (whiteList.indexOf(to.path) !== -1) {
//             // in the free login whitelist, go directly
//             next()
//         } else {
//             // other pages that do not have permission to access are redirected to the login page.
//             next(`/login`)
//             // NProgress.done()
//         }
//     }
// })


router.beforeEach(async(to, from, next) => {
    // set page title
    document.title = getPageTitle(to.meta.title)
    const {username, password} = JSON.parse(localStorage.getItem('loginInfo')) ?? {};
    var un,ps;
    un=username;
    ps=password;
    // determine whether the user has logged in
    var hasToken = getToken();

    var toPath = to.path;
    var quer = to.query;
    var isSimple = false
    // console.log('abc',toPath,quer,hasToken)

    // ============================================================
    // 访客会话路由限制
    // 使用 sessionStorage 标志检测（而非cookie，因为HttpOnly cookie JS不可读）
    // 访客只能访问工单查看/填写页面，其他路由重定向到登录页
    // ============================================================
    if (isGuestSession() && !toPath.startsWith('/WorkSheet/SheetViewParent') && whiteList.indexOf(to.path) === -1) {
        next('/login')
        return
    }
    if (toPath.startsWith('/WorkSheet/SheetViewParent/') && quer.token ){
        // console.log('a1')

        // token格式（新）: {sheetId}_{inviteTokenGUID}（sheetId=整数, inviteToken=GUID无横线）
        // token格式（旧）: {encryptedUserId}_{encryptedDate}（两个32位MD5哈希）
        //   旧格式需从URL路径中提取sheetId拼接成3段: {encryptedSheetId}_{encryptedUserId}_{encryptedDate}
        var token = quer.token
        var parts = token.split('_')
        if (parts.length === 2 && parts[0].length === 32 && parts[1].length === 32) {
            // 两个32位MD5 = 旧格式，补上路径中的sheetId
            var dataid = toPath.replace('/WorkSheet/SheetViewParent/', '')
            token = dataid + '_' + token
        }
        // console.log(dataid,quer.token)
        // var aa = await store.dispatch('user/quickLogin', {token:quer.token,toPath})

        // localStorage.removeItem('loginInfo');
        // removeToken();

        try {
            var aa = await store.dispatch('user/quickLogin2024', {token,toPath})
            isSimple = true
        } catch (e) {
            // QuickLogin 失败（token过期/无效/处理人变更等）
            // 错误消息已由 axios 拦截器显示（request.js）
            // 清除可能的残留状态，跳转到登录页
            console.log('[permission] QuickLogin failed:', e.message)
            clearGuestSessionFlag()
            removeToken()
            next('/login')
            return
        }
    }
    if (isSimple){
        // guest flow: allow the requested guest page only
        next()
        return
    }else{
        if (hasToken && un && ps) {
            if (to.path === '/login') {
                // if is logged in, redirect to the home page
                next({path: '/'})
                // NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
            } else {

                try {
                    // console.log('do',store.state.user,store.state.user.slideData)
                    // get user info
                    // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
                    await store.dispatch('user/getUserCompany', {un, ps});
                    if (!store.state.user?.slideData?.length) {
                        // console.log('jinru11111',un,ps)
                        await store.dispatch('user/login', {username:un, password:ps});
                        // console.log('do2',store.state.user.slideData)
                        await store.dispatch('user/getUserMenu');
                        // console.log('do3',store.state.user.slideData)
                    }
                    // console.log('do next'),
                    // hack method to ensure that addRoutes is complete
                    // set the replace: true, so the navigation will not leave a history record
                    next()
                } catch (error) {
                    removeToken();
                    next(`/login`)
                    // NProgress.done()
                }
            }
        } else {
            /* has no token*/

            if (whiteList.indexOf(to.path) !== -1) {
                // in the free login whitelist, go directly
                next()
            } else {
                // other pages that do not have permission to access are redirected to the login page.
                next(`/login`)
                // NProgress.done()
            }
        }
    }
})

// router.afterEach(() => {
//     // finish progress bar
//     NProgress.done()
// })